import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { useLocale } from '../context/LocaleContext';
import { useTheme } from '../context/ThemeContext';
import SafeIcon from '../common/SafeIcon';

export default function NotFoundPage() {
  const { locale, toggleLocale } = useLocale();
  const { isDark, toggleDark } = useTheme();
  const isZh = locale === 'zh-TW';

  return (
    <div className="min-h-screen bg-[#fffbf0] dark:bg-slate-900 flex flex-col transition-colors duration-300">
      <nav className="h-16 px-4 sm:px-6 flex items-center justify-between border-b border-gray-100 dark:border-slate-800 bg-white/70 dark:bg-slate-900/80 backdrop-blur-lg">
        <Link to="/" className="flex items-center gap-2 font-black text-gray-800 dark:text-white">
          <div className="bg-gradient-to-br from-pink-400 to-rose-400 text-white p-2 rounded-xl shadow-sm rotate-3">
            <SafeIcon name="Heart" className="w-5 h-5" />
          </div>
          <span>DaysMatter</span>
        </Link>
        <div className="flex items-center gap-3">
          <button
            onClick={toggleLocale}
            className="w-9 h-9 rounded-full bg-gray-100 dark:bg-slate-800 text-gray-500 dark:text-gray-400 font-bold text-sm"
            title={isZh ? '切換語言' : 'Switch language'}
          >
            {isZh ? 'EN' : '中'}
          </button>
          <button
            onClick={toggleDark}
            className="w-9 h-9 rounded-full bg-gray-100 dark:bg-slate-800 text-gray-500 dark:text-yellow-400 flex items-center justify-center"
            title={isZh ? '切換主題' : 'Switch theme'}
          >
            <SafeIcon name={isDark ? 'Moon' : 'Sun'} className="w-5 h-5" />
          </button>
        </div>
      </nav>

      <main className="flex-1 flex items-center justify-center p-6">
        <motion.div
          initial={{ opacity: 0, y: 24, rotate: -1 }}
          animate={{ opacity: 1, y: 0, rotate: 0 }}
          className="w-full max-w-xl text-center hand-drawn-box bg-white dark:bg-slate-800 p-8 sm:p-12"
        >
          <div className="text-7xl sm:text-8xl mb-6" aria-hidden="true">🗓️</div>
          <p className="text-pink-500 dark:text-pink-400 font-black tracking-widest mb-3">
            404
          </p>
          <h1 className="text-3xl sm:text-4xl font-black text-gray-800 dark:text-white mb-4">
            {isZh ? '這個日子找不到了嗎？' : 'Has This Day Gone Missing?'}
          </h1>
          <p className="text-gray-600 dark:text-gray-300 font-medium leading-relaxed mb-8">
            {isZh
              ? '你造訪的頁面不存在或已經移動，回到首頁繼續珍藏每一個重要日子吧！'
              : 'The page you visited does not exist or has moved. Return home to keep treasuring every important day!'}
          </p>
          <Link
            to="/"
            className="inline-flex items-center gap-2 px-7 py-3.5 bg-gray-900 dark:bg-white text-white dark:text-gray-900 font-bold rounded-xl shadow-lg hover:-translate-y-1 hover:shadow-xl transition-all active:scale-95"
          >
            <SafeIcon name="ArrowLeft" className="w-5 h-5" />
            <span>{isZh ? '返回首頁' : 'Back to Home'}</span>
          </Link>
        </motion.div>
      </main>
    </div>
  );
}